import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
/* import {Provider} from "react-redux"; 
import {store} from "./Store"; 
import reportWebVitals from "./reportWebVitals"; */
import {AppContext,langdata} from "Resources";


const language=langdata.english;
window.language=Object.freeze({
    ...language,
    get:(key)=>language[key]||key||"",
});

const root=ReactDOM.createRoot(document.getElementById("root"));
root.render(
    //<React.StrictMode>
    //<Provider store={store}>
    <AppContext>
        <App/>
    </AppContext>
    //</Provider>
    //</React.StrictMode> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
